import React, { useEffect, useState } from "react";
import moment from "moment";
const Closetrade = ({
  name,
  expary,
  ordertimrdate,
  bidtype,
  holdingmargin,
  marginused,
  bid,
  profit,
  brokrage,
  lot,
  sellprice,
  orderDatetime,
  orderupdatetime,
  closeordertype,
  ordertype1,
}) => {
  const profitloss = parseFloat(profit);
  const [close, setClose] = useState("");
  const [closeorder, setcloseorder] = useState("");
  const [color, setcolour] = useState("");

  console.log(color);

  console.log("ordertime", ordertimrdate);
  console.log("orderdelettime", orderDatetime);
  console.log("update", orderupdatetime);
  console.log("bidtype", bidtype);
  console.log("ordertyoe", ordertype1);
  console.log("closeordertype", closeordertype);

  useEffect(() => {
    if (ordertype1 == 1) {
      setClose("Market");
      setcolour("'green'");
    } else if (ordertype1 == 2) {
      setClose("Order");
    } else if (ordertype1 == 3) {
      setClose("SL");
    } else if (ordertype1 == 4) {
      setClose("Admin");
    } else if (ordertype1 == 5) {
      setClose("Carried Forward");
      setcolour("'red'");
    } else if (ordertype1 == 6) {
      setClose("Month Settlement");
    }

    if (closeordertype == 1) {
      setcloseorder("market");
    } else if (closeordertype == 2) {
      setcloseorder("Order");
    } else if (closeordertype == 3) {
      setcloseorder("SL");
    } else if (closeordertype == 4) {
      setcloseorder("Admin");
    } else if (closeordertype == 5) {
      setcloseorder("Carried Forward");
      setcolour("'red'");
    } else if (closeordertype == 6) {
      setcloseorder("I-found");
    } else if (closeordertype == 7) {
      setcloseorder("Month Settlement");
    }
  });
  return (
    <>
      <div className="futures_List">
        <div className="trades_List_text">
          <h3>
            {name}_{expary}
          </h3>
          <h5 style={{ marginBottom: "13px", marginTop: "13px" }}>
            Sold by Trader{" "}
            {bidtype == 1 ? (
              <span
                style={{
                  border: "1px solid red",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "red",
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {" "}
                {sellprice}
              </span>
            ) : (
              <span
                style={{
                  border: "1px solid red",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "red",
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {bid}
              </span>
            )}
          </h5>
          {bidtype == 1 ? (
            <p style={{ display: "flex" }}>
              {moment(orderupdatetime, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MMM-YY HH:mm",
              )}{" "}
              <span
                style={{
                  overflow: "hidden",
                  webkitLineClamp: "1",
                  webkitBoxOrient: "vertical",
                  width: "60px",
                  display: "-webkit-box",
                  borderColor: { color },
                  border: "1px solid ",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: { color },
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {closeorder}
              </span>
            </p>
          ) : (
            <p style={{ display: "flex" }}>
              {moment(ordertimrdate, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MMM-YY HH:mm",
              )}{" "}
              <span
                style={{
                  overflow: "hidden",
                  webkitLineClamp: "1",
                  webkitBoxOrient: "vertical",
                  width: "60px",
                  display: "-webkit-box",
                  borderColor: { color },
                  border: "1px solid ",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: { color },
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {close}
              </span>
            </p>
          )}
        </div>
        <div className="trades_List_text text-right">
          <div className="trades_amount_btn" style={{ marginBottom: "0px" }}>
            {profitloss > 0 && (
              <span
                style={{
                  border: "1px solid green",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "green",
                  borderRadius: "5px",
                  fontSize: "12px",
                }}
              >
                {profit}/-{brokrage}
              </span>
            )}
            {profitloss < 0 && (
              <span
                style={{
                  border: "1px solid red",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "red",
                  borderRadius: "5px",
                  fontSize: "12px",
                }}
              >
                {profit}/-{brokrage}
              </span>
            )}
            {profitloss > 0 && (
              <span
                style={{
                  border: "1px solid green",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "green",
                  borderRadius: "5px",
                  fontSize: "12px",
                }}
              >
                Qty:{lot}
              </span>
            )}
            {profitloss < 0 && (
              <span
                style={{
                  border: "1px solid red",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "red",
                  borderRadius: "5px",
                  fontSize: "12px",
                }}
              >
                Qty:{lot}
              </span>
            )}
          </div>
          <h4 style={{ marginBottom: "13px", marginTop: "13px" }}>
            Bought by Trader{" "}
            {bidtype == 1 ? (
              <span
                style={{
                  border: "1px solid #4bad00",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "#4bad00",
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {bid}{" "}
              </span>
            ) : (
              <span
                style={{
                  border: "1px solid #4bad00",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: "#4bad00",
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {sellprice}
              </span>
            )}
            {/* {bid} */}
            {/* {sellprice} */}{" "}
          </h4>
          {/* <p style={{ display: "flex" }}>
            {" "}
            {moment(orderDatetime, "DD-MM-YYYY HH:mm:ss").format(
              "DD-MMM-YY HH:mm"
            )}{" "}
            <span
              style={{
                overflow: "hidden",
                webkitLineClamp: "1",
                webkitBoxOrient: "vertical",
                width: "60px",
                display: "-webkit-box",
                border: "1px solid #4bad00",
                marginRight: "5px",
                padding: "2px 10px",
                color: "#4bad00",
                borderRadius: "10px",
                fontSize: "10px",
                background: "transparent",
              }}
            >
              {closeorder}
            </span>
          </p> */}
          {bidtype == 2 ? (
            <p style={{ display: "flex" }}>
              {moment(orderupdatetime, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MMM-YY HH:mm",
              )}{" "}
              <span
                style={{
                  overflow: "hidden",
                  webkitLineClamp: "1",
                  webkitBoxOrient: "vertical",
                  width: "60px",
                  display: "-webkit-box",
                  borderColor: { color },
                  border: "1px solid ",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: { color },
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {closeorder}
              </span>
            </p>
          ) : (
            <p style={{ display: "flex" }}>
              {moment(orderDatetime, "DD-MM-YYYY HH:mm:ss").format(
                "DD-MMM-YY HH:mm",
              )}{" "}
              <span
                style={{
                  overflow: "hidden",
                  webkitLineClamp: "1",
                  webkitBoxOrient: "vertical",
                  width: "60px",
                  display: "-webkit-box",
                  borderColor: { color },
                  border: "1px solid ",
                  marginRight: "6px",
                  padding: "2px 10px",
                  color: { color },
                  borderRadius: "5px",
                  fontSize: "12px",
                  background: "transparent",
                }}
              >
                {close}
              </span>
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default Closetrade;
